import axiosInstance from "./axios/axios.js";
import { Decrypt_Value } from "./MiddleWare/EncryptDecrypt/index.js";

let isLoggingOut = false;

const logout = (userid = "", sessionout = false) => {
  if (isLoggingOut) return;
  isLoggingOut = true;

  try {
    if (!userid) {
      const storedId = localStorage.getItem("user_id");
      if (storedId) {
        userid = Decrypt_Value(storedId, "vozo");
      }
    }

    localStorage.removeItem("passModalSeen");
    const token = localStorage.getItem("csrfToken") || "";

    axiosInstance
      .post(`/vozo/updatelogout?id=${token}&uid=${userid || ""}`)
      .catch((err) => {
        console.error("Logout API failed:", err?.response || err.message);
      })
      .finally(() => {
        try {
          localStorage.clear();

          if (sessionout) {
            localStorage.setItem("timeoutmsg", true);
          } else {
            localStorage.setItem("logout", true);
          }
        } finally {
          isLoggingOut = false;
          window.location.href = "/";
        }
      });
  } catch (err) {
    console.error("Logout crash:", err);

    localStorage.clear();
    isLoggingOut = false;
    window.location.href = "/";
  }
};

export default logout;
